function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
import link from './link.js';
var schema = defineObject('programsListSectionProgram', {
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    icon: _object_spread({
        title: 'Icon'
    }, requiredImage.fragment),
    action: {
        title: 'Action',
        type: 'link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    title: z.string(),
    description: simpleBlockContent.validator,
    icon: requiredImage.validator,
    link: link.validator
}).partial();
schema.programsListSectionProgram;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=programsListSectionProgram.js.map